export const GrocerGridCard =   [
                                                
    {
    "id": "64a7a4ef02878f0001e7e0be",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/0a688af1-1bb4-4a55-8128-31fc79cc9ad0_6d0abb9a-daff-4fbe-a1c9-2dddb6ae6717",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Fresh Vegetables",
        "text": "Fresh Vegetables",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "64a7a4ef02878f0001e7e0be",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Fresh Vegetables"
}, {
    "id": "5f2c18a68ac42c7d7c3efee2",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/85df9d8f-175f-4e3a-8945-468bf6317eee_eb9bf247-f2d1-413d-9cf5-48bc870b222f",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Fresh Fruits",
        "text": "Fresh Fruits",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "5f2c18a68ac42c7d7c3efee2",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Fresh Fruits"
}, {
    "id": "5f2c18a68ac42c7d7c3efeeb",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/a3b15dce-c4b5-4533-89d6-b1c1fb566dbe_4f9ede4c-dc43-4db6-a124-2dd34b7476eb",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Dairy, Bread and Eggs",
        "text": "Dairy, Bread and Eggs",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "5f2c18a68ac42c7d7c3efeeb",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Dairy, Bread and Eggs"
}, {
    "id": "618926e2b6244b11ebb4efd0",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/77735db8-b5cd-4382-91d6-dfbd46b08a6f_6b8a53d6-677f-48aa-9c9e-ae8e4adfb2eb",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Atta, Rice and Dals",
        "text": "Atta, Rice and Dals",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "618926e2b6244b11ebb4efd0",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Atta, Rice and Dals"
}, {
    "id": "61892f82b6244b11ebb4efd9",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/5d8c440a-39a5-4cd8-ba0d-980934aa6cca_87c90adc-244f-41fe-9bf3-80c8be9d59ee",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Masalas and Dry Fruits",
        "text": "Masalas and Dry Fruits",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "61892f82b6244b11ebb4efd9",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Masalas and Dry Fruits"
}, {
    "id": "64a7c4e45e365e0001d10d54",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/f53f0a27-22a2-435a-9a65-aa1203340923_61b91ee1-a63b-40c6-b802-8f143474b098",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Oils and Ghee",
        "text": "Oils and Ghee",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "64a7c4e45e365e0001d10d54",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Oils and Ghee"
}, {
    "id": "5f2c18a68ac42c7d7c3eff13",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/2ead57e4-00b3-4525-91b2-9eb37a4be375_eee95c8a-e736-42ed-ab86-46add6ffe374",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Munchies",
        "text": "Munchies",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "5f2c18a68ac42c7d7c3eff13",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Munchies"
}, {
    "id": "5f2c18a68ac42c7d7c3eff19",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/9314636d-dcb2-468b-bdad-9170f4133e14_00e24371-61a6-4ab5-98e9-552bb94d2557",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Sweet Tooth",
        "text": "Sweet Tooth",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "5f2c18a68ac42c7d7c3eff19",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Sweet Tooth"
}, {
    "id": "627381b740a2340975ce565d",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/8344b7d1-c41a-4225-8b1d-8a2de011780a_0b366fdd-d4ab-467e-9349-c8ec57f65cda",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Cold Drinks and Juices",
        "text": "Cold Drinks and Juices",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "627381b740a2340975ce565d",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Cold Drinks and Juices"
}, {
    "id": "6166723cf909db209da87988",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/c1d3779d-9b01-4853-8cad-99185e39c933_a0e15a76-ea59-47e6-a98e-0bb4dfc40600",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Biscuits and Cakes",
        "text": "Biscuits and Cakes",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "6166723cf909db209da87988",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Biscuits and Cakes"
}, {
    "id": "5f2c18a68ac42c7d7c3eff21",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/67be61b3-99b4-4037-823c-a2cf0155b0af_00bd4c81-9099-4868-be16-0fdeb382a8dc",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Instant and Frozen Food",
        "text": "Instant and Frozen Food",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "5f2c18a68ac42c7d7c3eff21",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Instant and Frozen Food"
}, {
    "id": "639c29f84a232c09b5746701",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/9/4e5eec2b-4797-4a93-989a-71b0f5958a3f_cae7e951-fc56-4886-86dd-f583e2373c52",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Hygiene and Wellness",
        "text": "Hygiene and Wellness",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c29f84a232c09b5746701",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Hygiene and Wellness"
}, {
    "id": "5fa649c88ac42c7d7c3fa537",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/e33d8321-cb8c-4732-9149-beb834eb24e4_8cee91b0-a380-43bb-90cf-9346a322ebeb",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Meat and Seafood",
        "text": "Meat and Seafood",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "5fa649c88ac42c7d7c3fa537",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Meat and Seafood"
}, {
    "id": "618a0138b6244b11ebb4efe7",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/7c574228-ae92-4199-a45b-dfc3229c09e7_69a4ac73-d9f5-498b-a5cc-40afd90ee4b0",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Cleaning Essentials",
        "text": "Cleaning Essentials",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "618a0138b6244b11ebb4efe7",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Cleaning Essentials"
}, {
    "id": "639c4c0dbab88e09e85bebac",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/e50a580b-4bd7-449a-af9e-fbf01ea18843_e5e21b56-781f-4ccd-b431-a343a23fecb3",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Bath, Body and Hair",
        "text": "Bath, Body and Hair",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c4c0dbab88e09e85bebac",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Bath, Body and Hair"
}, {
    "id": "639c65291555a809f1267d10",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/ed1b860f-4fc6-421e-ace8-3c2bde3fc676_3404cf52-d2ad-43db-a349-0846871ddcfa",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Cereals and Breakfast",
        "text": "Cereals and Breakfast",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c65291555a809f1267d10",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Cereals and Breakfast"
}, {
    "id": "639c68fe4a232c09b5746758",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/977de398-06fe-4d77-bc77-55158c438dad_9aa7f78a-9590-4625-88e7-520cc29ae3f7",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Sauces and Spreads",
        "text": "Sauces and Spreads",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c68fe4a232c09b5746758",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Sauces and Spreads"
}, {
    "id": "5f2c18a68ac42c7d7c3eff08",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/5eee5690-8002-4e28-95df-cc73280a11ed_dec84cd0-4e9d-4c2b-a41f-5aee59fb9ca8",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Tea, Coffee and More",
        "text": "Tea, Coffee and More",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "5f2c18a68ac42c7d7c3eff08",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Tea, Coffee and More"
}, {
    "id": "5fe4539179e93b591ec721bc",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/5/9/61933ca1-f2fa-443a-910d-feb2ab6ecf79_c849fce4-cdab-4317-8fb5-b6dff377dba9",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Paan Corner",
        "text": "Paan Corner",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "5fe4539179e93b591ec721bc",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Paan Corner"
}, {
    "id": "639c51e24a232c09b5746727",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/0798c1d0-34e0-4f87-a7eb-38183c69d743_7cb04bf5-5a28-49dd-b2cc-672650059671",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Home and Kitchen",
        "text": "Home and Kitchen",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c51e24a232c09b5746727",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Home and Kitchen"
}, {
    "id": "639c6085bab88e09e85bebd5",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/e2f8a4f3-aad4-446d-994e-8e2481661937_7552c2b7-78bf-42c6-b988-b94b3e1015dc",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Office and Electricals",
        "text": "Office and Electricals",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c6085bab88e09e85bebd5",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Office and Electricals"
}, {
    "id": "639c5b774a232c09b5746739",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/2/84be94e2-53ad-451b-aeda-58538d5e3cc4_8c0cc6f4-9722-49ad-9ebe-6cc41d4b8d87",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Baby Care",
        "text": "Baby Care",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c5b774a232c09b5746739",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Baby Care"
}, {
    "id": "639c5d0f1555a809f1267d00",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/18/d2a2bb44-cbc0-47f5-80b0-4bfb6d328783_9f37b5c9-5f58-4491-808c-6a42c816d047",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Pet Supplies",
        "text": "Pet Supplies",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c5d0f1555a809f1267d00",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Pet Supplies"
}, {
    "id": "639c5ee31555a809f1267d05",
    "imageId": "NI_CATALOG/IMAGES/CIW/2024/4/22/145553bd-115f-4010-9ac3-74682811cca4_ba1e6bf6-d66f-4d19-8f3a-4cc208b6d679",
    "action": {
        "link": "https://www.swiggy.com/instamart/category-listing?categoryName=Beauty and Grooming",
        "text": "Beauty and Grooming",
        "type": "DEEPLINK"
    },
    "accessibility": {},
    "entityId": "639c5ee31555a809f1267d05",
    "frequencyCapping": {},
    "externalMarketing": {},
    "description": "Beauty and Grooming"
}]
